<footer class="footer-area w-full bg-white">
    
    <div class="footer-bottom">
        <div class="grid">
            <div class="col-12">
                <div
                    class="copyright-area flex flex-wrap justify-content-center justify-content-sm-between text-center p-4">
                    <div class="text-center">©Copyrights 2025 SIMESCCO TECNOLOGÍA S.A.S. Todos los derechos reservados.
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer> 
